import { color, spacing, media } from "@universityofmaryland/web-token-library";
import "../../typography/font-face/index.js";
import "../../typography/campaign.js";
import "../../typography/elements.js";
import { large } from "../../typography/sans.js";
import "../../typography/serif.js";
import "../../typography/stats.js";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
import { valid, invalid } from "./_state.js";
const classNamePrefix = "umd-field-set";
const wrapper = objectWithClassName({
  className: [
    `${classNamePrefix}-wrapper`,
    /** @deprecated Use 'umd-field-set-wrapper' instead */
    "umd-forms-layout-fieldset-list"
  ],
  "& > *": {
    alignItems: "flex-start",
    marginTop: spacing.md,
    "&:first-of-type": {
      marginTop: 0
    }
  },
  "& > legend": {
    ...large,
    marginBottom: spacing.sm,
    position: "relative",
    [`@media (${media.queries.large.min})`]: {
      gridColumn: "span 2"
    }
  },
  "&[required] > legend::after": {
    content: "' *'",
    color: color.redDark
  },
  "&[aria-invalid='true']": {
    ...invalid,
    border: 0
  },
  "&[aria-invalid='false']": {
    ...valid,
    border: 0
  }
});
export {
  wrapper
};
//# sourceMappingURL=set.js.map
